// extracted by mini-css-extract-plugin
module.exports = {"btnLink":"assistTabs_btnLink_16RDobd"};